
export class CouponStatus {
	public static Created = 'created';
	public static Invited = 'invited';
	public static Played = 'Played';
	public static Expired = 'expired'; // for unlimied play coupons
}
